<template>
  <div>
    <div v-if="isDesktopSize" class="gallery-carousel">
      <figure class="gallery-item-1">
        <img
          src="/static/pictures/mock/gallery-item-1.jpg"
          class="gallery-img"
          alt=""
        />
      </figure>
      <figure class="gallery-item-2">
        <img
          src="/static/pictures/mock/gallery-item-2.jpg"
          class="gallery-img"
          alt=""
        />
      </figure>
      <figure class="gallery-item-3">
        <img
          src="/static/pictures/mock/gallery-item-3.jpg"
          class="gallery-img"
          alt=""
        />
      </figure>
      <figure class="gallery-item-4">
        <img
          src="/static/pictures/mock/gallery-item-4.jpg"
          class="gallery-img"
          alt=""
        />
      </figure>
      <figure class="gallery-item-5">
        <img
          src="/static/pictures/mock/gallery-item-5.jpg"
          class="gallery-img"
          alt=""
        />
      </figure>
    </div>
    <div v-else class="slides">
      <slick-carousel
        :images="slides"
        :autoplay="true"
        :arrows="windowHeight > MSize"
      >
      </slick-carousel>
    </div>
  </div>
</template>

<script>
import slickCarousel from '../../../../lib/components/slickCarousel';
import { lSize, mSize } from "../VariableStatic";

export default {
  components: {
    "slick-carousel" :slickCarousel
  },
  data() {
    const slides = [
      "/static/pictures/mock/gallery-item-1.jpg",
      "/static/pictures/mock/gallery-item-2.jpg",
      "/static/pictures/mock/gallery-item-3.jpg",
      "/static/pictures/mock/gallery-item-4.jpg",
      "/static/pictures/mock/gallery-item-5.jpg",
    ];
    return {
      slides,
      windowHeight: window.innerWidth,
      MSize: mSize,
    };
  },
  computed: {
    isDesktopSize() {
      return this.windowHeight > lSize;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-carousel {
  display: grid;
  grid-template-columns: repeat(12, 2fr);
  grid-template-rows: repeat(11, 5vw);
  grid-column-gap: 10px;
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gallery-item-1 {
  grid-column-start: 1;
  grid-column-end: 13;
  grid-row-start: 1;
  grid-row-end: 5;
}

.gallery-item-2 {
  grid-column-start: 1;
  grid-column-end: 7;
  grid-row-start: 5;
  grid-row-end: 8;
}

.gallery-item-3 {
  grid-column-start: 7;
  grid-column-end: 13;
  grid-row-start: 5;
  grid-row-end: 8;
}

.gallery-item-4 {
  grid-column-start: 1;
  grid-column-end: 7;
  grid-row-start: 8;
  grid-row-end: 11;
}

.gallery-item-5 {
  grid-column-start: 7;
  grid-column-end: 13;
  grid-row-start: 8;
  grid-row-end: 11;
}

.slides {
  width: 100%;
}
</style>
